export const AVERAGE_EXPENDITURE = 0.9105

export const DEFAULT_SPENDING_CATEGORIES = [
  {
    displayName: 'Food and Drink',
    name: 'Food and Drink',
    parentUuid: '644749fe-562b-11ea-9b3e-0a3037b37e81',
    uuid: '64479ef4-562b-11ea-9b3e-0a3037b37e81',
  },
  {
    displayName: 'Shopping',
    name: 'Shops',
    parentUuid: '644a1f3e-562b-11ea-9b3e-0a3037b37e81',
    uuid: '644995a3-562b-11ea-9b3e-0a3037b37e81',
  },
  {
    displayName: 'Gas',
    name: 'Travel',
    parentUuid: '644a60ba-562b-11ea-9b3e-0a3037b37e81',
    uuid: '644a97cf-562b-11ea-9b3e-0a3037b37e81',
  },
  {
    displayName: 'Entertainment',
    name: 'Recreation',
    parentUuid: '644a1f3e-562b-11ea-9b3e-0a3037b37e81',
    uuid: '64483c82-562b-11ea-9b3e-0a3037b37e81',
  },
  {
    displayName: 'Travel and Transport',
    name: 'Travel',
    parentUuid: '644a1f3e-562b-11ea-9b3e-0a3037b37e81',
    uuid: '644a60ba-562b-11ea-9b3e-0a3037b37e81',
  },
  {
    displayName: 'Uncategorized',
    name: 'Everything',
    parentUuid: '644749fe-562b-11ea-9b3e-0a3037b37e81',
    uuid: '644749fe-562b-11ea-9b3e-0a3037b37e81',
  },
]

export const DEFAULT_SPENDING_CATEGORY_PERCENTAGES = {
  '644749fe-562b-11ea-9b3e-0a3037b37e81': 0.1768,
  '64479ef4-562b-11ea-9b3e-0a3037b37e81': 0.1389,
  '64483c82-562b-11ea-9b3e-0a3037b37e81': 0.0527,
  '644995a3-562b-11ea-9b3e-0a3037b37e81': 0.0305,
  '644a60ba-562b-11ea-9b3e-0a3037b37e81': 0.0323,
  '644a97cf-562b-11ea-9b3e-0a3037b37e81': 0.0344,
}
